module.exports = __webpack_public_path__ + "img/puertoRico.ef8595ff.jpg";